import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOGIN_ACTIVITY_KEY } from '@senderra/shared/constants';

export enum SubdomainStatus {
    VALID = 'valid',
    INVALID = 'invalid',
}

interface AuthState {
    token: string | null;
    isLoggedIn: boolean;
    subdomainValid: SubdomainStatus | null;
    loginActivityComplete: boolean;
    authError: boolean;
}

const initialState: AuthState = {
    token: null,
    isLoggedIn: false,
    subdomainValid: null,
    loginActivityComplete: localStorage.getItem(LOGIN_ACTIVITY_KEY) === 'true' ? true : false,
    authError: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string | null>) => {
            state.token = action.payload;
        },
        setLoggedInStatus: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },
        setSubdomainValid: (state, action: PayloadAction<SubdomainStatus>) => {
            state.subdomainValid = action.payload;
        },
        setLoginActivityComplete(state, action: PayloadAction<boolean>) {
            state.loginActivityComplete = action.payload;
        },
        setAuthError(state, action: PayloadAction<boolean>) {
            state.authError = action.payload;
        },
    },
});

export const { setToken, setLoggedInStatus, setSubdomainValid, setLoginActivityComplete, setAuthError } =
    authSlice.actions;
export default authSlice.reducer;
